import { ComponentPropsWithoutRef } from 'react';

import { iconSize, IconSizeProps } from '@/types/icons';
import { cn } from '@/utils/cn';

export const IconGarbageTruck = ({ size, className }: IconSizeProps & ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      fill="currentColor"
      className={cn(iconSize[size], className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      xmlSpace="preserve"
    >
      <path
        d="M8 5.5V13.5C8 14.0523 8.44569 14.5 8.99798 14.5H18.5C19.2026 14.5 19.4166 14.9501 19.479 15.5007C19.5411 16.0495 19.9477 16.5 20.5 16.5H21.6765C22.3402 16.5 22.8198 15.8653 22.6385 15.2268L19.799 5.22685C19.6769 4.79676 19.2841 4.5 18.837 4.5H9C8.44772 4.5 8 4.94772 8 5.5Z"
        strokeWidth="2" />
      <path
        d="M1.5 13V17C1.5 17.5523 1.94771 18 2.49999 18L3.5 18M1.5 13L3.27208 7.68377C3.40819 7.27543 3.79033 7 4.22076 7H7C7.55228 7 8 7.44772 8 8V13M1.5 13L8 13M8 13V13.5C8 14.0523 8.44772 14.5 9 14.5H18.5C19.0523 14.5 19.5 14.9477 19.5 15.5V17C19.5 17.5523 19.0523 18 18.5 18H17M3.5 18C3.5 18.6667 3.5 21.5 6 21.5C8.5 21.5 8.5 18.6667 8.5 18M3.5 18L8.5 18M8.5 18H12M12 18C12 18.6667 12 21.5 14.5 21.5C17 21.5 17 18.6667 17 18M12 18L17 18"
        strokeWidth="2" />
    </svg>
  );
};
